import { service, model } from 'eco-cli'

const { compatibility } = service;

import { Adapter } from '@/models/Adapter.js'

// 获取项目详情
export const getProjectInfo = (projectId) =>
  compatibility
    .get("/apply/distribution/queryById", { id: projectId })
    .then((res) => {
      return Adapter.fromServer(res);
    });

// 获取用户申请的所有项目
export const getProjectOfCurrentUser = () =>
  compatibility.withToken.get("/apply/distribution/allApply").then((res) => {
    return res.map((v) => Adapter.fromServer(v));
  });

// 提交申请
export const applyForProject = (apply) =>
  compatibility.withToken.post("/apply/distribution/add", apply.toServer());

//提交评价
export const addRate = ({ id, rate = 5, rateContent = '暂无' }) => compatibility.withToken.post('/apply/distribution/publishEvaluate', {
  id,
  starRating: rate,
  starSuggest: rateContent
})
